import FeaturesContainer from './FeaturesContainer';
import useImagesSrc from '../../helper/useImagesSrc';

const ShareFlight = ({ history, onePage }) => (
  <FeaturesContainer
    history={history}
    onePage={onePage}
    title={'share_flight'}
    adaptiveHeight={830}
    eventName={'onboardingFlightStatus'}
    nextPage={'/auto-sos'}
    imagePreload={useImagesSrc().imagesSources.emergencyAlert}
    imageName={'FlightStatus'}
    imageAlt={'Share your flights status'}
  />
);

export default ShareFlight
